const isElementNode = (node) => node && node.nodeType === 1;

const isBreakNode = (node) => isElementNode(node) && node.tagName === 'BR';

const isTranslatableTextNode = (node) => (
  isElementNode(node) &&
  node.classList &&
  node.classList.contains('js-translatable-text')
);

const getOrderedMessageNodes = (container) => {
  if (!container || !container.childNodes) return [];

  return Array.from(container.childNodes).filter(node => (
    isBreakNode(node) || isTranslatableTextNode(node)
  ));
};

const groupChineseMessageNodes = (nodes, containsChinese) => {
  const groups = [];
  let currentNonChineseGroup = null;

  const flushNonChineseGroup = () => {
    if (!currentNonChineseGroup) return;

    groups.push(currentNonChineseGroup);
    currentNonChineseGroup = null;
  };

  Array.from(nodes || []).forEach((node) => {
    if (isBreakNode(node)) {
      flushNonChineseGroup();
      groups.push({
        translate: false,
        elements: [node],
        preserveBoundary: true,
      });
      return;
    }

    if (containsChinese(node.textContent)) {
      flushNonChineseGroup();
      groups.push({
        translate: true,
        elements: [node],
      });
      return;
    }

    if (!currentNonChineseGroup) {
      currentNonChineseGroup = {
        translate: false,
        elements: [],
      };
    }
    currentNonChineseGroup.elements.push(node);
  });

  flushNonChineseGroup();
  return groups;
};

module.exports = {
  getOrderedMessageNodes,
  groupChineseMessageNodes,
};
